/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Grid, virtualizedGridRenderer } from '@integec/grid-tools'
import {
  Button,
  DatePicker,
  Select,
  Tabs,
  message,
  Menu,
  Dropdown,
  Checkbox,
} from 'antd'
import TextArea from 'antd/lib/input/TextArea'
import { wind2PlantSelection, wind2AllSubgroup, wind2AllPlant } from 'api/pgads'
import { DatePickerContext, ErrorContext, SpinContext } from 'context'
import { exportData, getApiTargetInfo, rowHeaderRender } from 'core'
import { Content, CriteriaRow, FullHeightSizer, Title } from 'core/screen-util'
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { connect } from 'react-redux'
import R from 'ramda'
import {
  getWind2EventNestedXML,
  getWind2PlantXML,
  getWind2SubgroupPerformanceXML,
  getWind2SubgroupXML,
  getWindStoragePerformanceXML,
  getWindStorageXML,
} from './xmldata'
import {
  getWind2PlantXLSX,
  getWind2SubgroupXLSX,
  getWind2SubgroupPerformanceXLSX,
  getWind2EventNestedXLSX,
  getWind2EventSubgroupPerformanceXLSX,
  getWind2StorageXLSX,
  getWind2StoragePerformanceXLSX,
} from './excelData'
import {
  JcTmpErrorTable,
  isErrorContains,
} from '../../core/component/JcTmpErrorDialog'
import {
  wind2FileEventSubgroupPerformance,
  wind2FileEvents,
  wind2FilePlants,
  wind2FileStorage,
  wind2FileStoragePerformance,
  wind2FileSubgroup,
  wind2FileSubgroupPerformance,
  windStorageGroup,
} from 'wind2/wind2api'
import { Wind2NercEventHeaders, Wind2PerformanceIoHeaders } from 'wind2/Headers'
import {
  NercEventHeaders,
  PerformanceIoHeaders,
  PlantHeaders,
  SubgroupHeaders,
  Wind2StorageGroupHeaders,
  Wind2StoragePerformanceIoHeaders,
} from './windHeader'
import { Wind2PlantHeaders } from 'wind2/admin/Wind2Plant'
import moment from 'moment'
import { Wind2SubgroupHeaders } from 'wind2/admin/Wind2Subgroup'
import { writeToExcel } from 'core/component/xlsx-utils-excel'
import { saveAs } from 'file-saver'
import {
  getValidActivePlantList,
  getValidActivePlantWithStorageGroup,
  getValidPlantList,
} from '../wind2utils'
// import SolarPlantSelection from '../../solar/SolarPlantSelection'
import { Filler } from '../../core/screen-util'

const PLANT = 'Plant'
const SUB_GROUP = 'Subgroup'
const EVENT = 'Event'
const SUB_GROUP_PERFORMANCE = 'Subgroup_Performance'
const EVENT_SUB_GROUP_PERFORMANCE = 'Event_Subgroup_Performance'
const STORAGE = 'Storage'
const STORAGE_PERFORMANCE = 'Storage Performance'
const EXCEL = 'excel'
const XML = 'xml'

const Wind2FileCreation = ({ targetInfo }) => {
  const [data, setData] = useState([])
  const [data2, setData2] = useState([])
  const [activeKey, setActiveKey] = useState('data')
  const [platAllList, setPlantAllList] = useState([])
  const [activePlants, setActivePlants] = useState([])
  const { setError } = useContext(ErrorContext)
  const { setSpinning } = useContext(SpinContext)
  const { selectedDateRangePicker, setSelectedDateRagePicker } = useContext(
    DatePickerContext
  )
  const [jcTmpErrors, setJcTmpErrors] = useState([])
  const [plantSelected, setPlantSelected] = useState([])
  const [selectedType, setSelectedType] = useState(EVENT_SUB_GROUP_PERFORMANCE)
  const [plantNameMap, setPlantNameMap] = useState({})
  const [isRetrieved, setIsRetrived] = useState(false)
  const [plantList, setPlantList] = useState([])
  const [subGroupList, setSubGroupList] = useState([])
  const [storageGroupList, setStorageGroupList] = useState([])

  const onChange = _ => {
    setData([])
    setData2([])
    setJcTmpErrors([])
    setIsRetrived(false)
    setActiveKey('data')
  }

  useEffect(
    _ => {
      wind2AllSubgroup(targetInfo).fork(setError, setSubGroupList)
      windStorageGroup(targetInfo).fork(setError, setStorageGroupList)
    },
    [setError, targetInfo]
  )

  useEffect(
    _ => {
      // wind2AllPlant(targetInfo).fork(setError, setPlantAllList)
      wind2PlantSelection(targetInfo)({
        year: selectedDateRangePicker[1].format('YYYY'),
        month: selectedDateRangePicker[1].format('MM'),
      }).fork(setError, data => {
        // const sd = R.sortBy(R.prop('plantName'), data)
        // setPlantAllList(sd)
        // const namMap = R.compose(
        //   R.fromPairs,
        //   R.map(s => [s.plantId, s.plantName])
        // )(data)
        // setPlantNameMap(namMap)
        // if (sd[0] && sd[0].plantId) setPlantSelected(sd[0].plantId)
        setPlantList(data)
      })
      wind2AllPlant(targetInfo).fork(setError, data => {
        setActivePlants(
          data.filter(f => f.plantOwnershipStatus === 'AV').map(f => f.plantId)
        )
      })
    },
    [selectedDateRangePicker, setError, targetInfo]
  )

  useEffect(
    _ => {
      let stoList = []

      stoList = getValidPlantList(plantList, subGroupList, [])
      setPlantAllList(stoList)
      const namMap = R.compose(
        R.fromPairs,
        R.map(s => [s.plantId, s.plantName])
      )(stoList)
      setPlantNameMap(namMap)

      // if (!plantSelected && stoList[0] && stoList[0].plantId)
      //   setPlantSelected(stoList[0].plantId)
    },
    [plantList, subGroupList]
  )

  const sortEventData = pd => {
    // return pd.filter(f => f.recordId !== 'NOT')
    return pd
  }

  const retrieveData = _ => {
    if (!plantSelected || plantSelected.length <= 0) {
      message.warn('Please, Select Plant')
      return
    }

    if (!selectedType) {
      message.warn('Please, Select Data/XML  Type')
      return
    }

    const req = {
      plants: plantSelected,
      start: selectedDateRangePicker[0]
        .clone()
        .startOf('M')
        .format('YYYY-MM-DD'),
      end: selectedDateRangePicker[1]
        .clone()
        .endOf('M')
        .format('YYYY-MM-DD'),
    }
    const api =
      selectedType === PLANT
        ? wind2FilePlants
        : selectedType === EVENT
        ? wind2FileEvents
        : selectedType === SUB_GROUP
        ? wind2FileSubgroup
        : selectedType === SUB_GROUP_PERFORMANCE
        ? wind2FileSubgroupPerformance
        : selectedType === EVENT_SUB_GROUP_PERFORMANCE
        ? wind2FileEventSubgroupPerformance
        : selectedType === STORAGE
        ? wind2FileStorage
        : selectedType === STORAGE_PERFORMANCE
        ? wind2FileStoragePerformance
        : wind2FilePlants

    setSpinning(true)
    api(targetInfo)(req).fork(setError, data => {
      setSpinning(false)
      setIsRetrived(true)
      const errors = []
      const filteredData = new Map()
      const perfDataValidate = pd =>
        pd.forEach(e => {
          if (e.entityId && e.plantId && e.recordid && e.recordid === 'NOT') {
            // if (e.entityId && e.plantId) {
            const key = e.entityId + '-' + e.plantId
            if (!filteredData.has(key)) {
              filteredData.set(key, e)
              errors.push({
                severity: 1,
                errorCode: 0,
                errorMessage: `Plant ${plantNameMap[e.plantId] ||
                  e.plantId} is not level 2 validated in ${
                  e.year
                }-${e.month.toString().padStart(2, '0')}`,
              })
            }
          }
        })

      if (selectedType === PLANT) setData(sortPlantData(data.data))
      else if (selectedType === SUB_GROUP) setData(sortSubroupData(data.data))
      else if (selectedType === SUB_GROUP_PERFORMANCE) {
        setData(sortPerformacneData(data.data))
        perfDataValidate(data.data)
      } else if (selectedType === EVENT_SUB_GROUP_PERFORMANCE) {
        setData(sortEventData(R.uniq(data.eventData)))
        setData2(sortPerformacneData(data.performanceData))
        perfDataValidate(data.performanceData)
      } else if (selectedType === EVENT) {
        setData(sortEventData(R.uniq(data.data)))
      } else if (selectedType === STORAGE) {
        setData(sortStorageData(data.data))
      } else if (selectedType === STORAGE_PERFORMANCE) {
        setData(sortStoragePerformacneData(data.data))
      } else setData(data.data)

      // setData(data.data)
      let errs = [...errors, ...data.errors]
      errs = R.sortWith([
        R.descend(R.prop('severity')),
        R.ascend(R.prop('errorCode')),
        R.ascend(R.prop('errorMessage')),
      ])(errs)
      isErrorContains(errs) && setActiveKey('errors')
      setJcTmpErrors(errs)
    })
  }

  const sortSubroupData = data => {
    return data.map(d => {
      let eff = d.effectiveDate
      if (eff && eff.length > 0) eff = moment(eff).format('MM/DD/YYYY')
      let comm = d.commissionDate
      if (comm && comm.length > 0) comm = moment(comm).format('MM/DD/YYYY')
      return { ...d, effectiveDate: eff, commissionDate: comm }
    })
  }

  const sortPlantData = data =>
    data.map(d => ({
      ...d,
      effectiveDate:
        d.effectiveDate && moment(d.effectiveDate).format('MM/DD/YYYY'),
    }))

  const sortStorageData = data =>
    data.map(d => ({
      ...d,
      effectiveDate:
        d.effectiveDate && moment(d.effectiveDate).format('MM/DD/YYYY'),
      commisionDate:
        d.commisionDate && moment(d.commisionDate).format('MM/DD/YYYY'),
    }))

  const sortPerformacneData = data => {
    return R.sortBy(
      (a, b) => {
        if ((a.subgroupName || '') === 'TOTAL') return 100000
        else {
          return R.toLower((a && a.subgroupName) || '').localeCompare(
            R.toLower((b && b.subgroupName) || '')
          )
        }
      },
      //      data.filter(f => f.subgroupName !== 'TOTAL' && f.recordid !== 'NOT')
      data.filter(f => f.subgroupName !== 'TOTAL')
    )
  }

  const sortStoragePerformacneData = data => {
    return R.sortBy(
      (a, b) => {
        if ((a.storageGroupId || '') === 'TOTAL') return 100000
        else {
          return R.toLower((a && a.storageGroupId) || '').localeCompare(
            R.toLower((b && b.storageGroupId) || '')
          )
        }
      },
      //      data.filter(f => f.subgroupName !== 'TOTAL' && f.recordid !== 'NOT')
      data.filter(f => f.storageGroupId !== 'TOTAL')
    )
  }

  const windHeaders = useMemo(
    _ => {
      switch (selectedType) {
        case PLANT:
          return Wind2PlantHeaders
        case SUB_GROUP:
          return Wind2SubgroupHeaders
        case EVENT:
          return Wind2NercEventHeaders(1000, [])
        case SUB_GROUP_PERFORMANCE:
          return Wind2PerformanceIoHeaders
        case EVENT_SUB_GROUP_PERFORMANCE:
          return Wind2NercEventHeaders(1000, [])
        case STORAGE:
          return Wind2StorageGroupHeaders
        case STORAGE_PERFORMANCE:
          return Wind2StoragePerformanceIoHeaders
      }
    },
    [selectedType]
  )

  const effectivePlant = useMemo(
    _ => {
      switch (selectedType) {
        case PLANT:
          return platAllList
        case SUB_GROUP:
        case EVENT:
        case SUB_GROUP_PERFORMANCE:
        case EVENT_SUB_GROUP_PERFORMANCE:
          return getValidActivePlantList(
            platAllList,
            subGroupList,
            activePlants
          )
        case STORAGE:
        case STORAGE_PERFORMANCE:
          return getValidActivePlantWithStorageGroup(
            platAllList,
            storageGroupList,
            activePlants
          )
      }
    },
    [activePlants, platAllList, selectedType, subGroupList, storageGroupList]
  )

  const excelHeaders = useMemo(
    _ => {
      switch (selectedType) {
        case PLANT:
          return PlantHeaders
        case SUB_GROUP:
          return SubgroupHeaders
        case EVENT:
          return NercEventHeaders(1000, [])
        case SUB_GROUP_PERFORMANCE:
          return PerformanceIoHeaders
        case EVENT_SUB_GROUP_PERFORMANCE:
          return NercEventHeaders(1000, [])
        case STORAGE:
          return Wind2StorageGroupHeaders
        case STORAGE_PERFORMANCE:
          return Wind2StoragePerformanceIoHeaders
      }
    },
    [selectedType]
  )

  const xmlString = useMemo(
    _ => {
      switch (selectedType) {
        case PLANT:
          return getWind2PlantXML(data)
        case SUB_GROUP:
          return getWind2SubgroupXML(data)
        case EVENT:
          return getWind2EventNestedXML(data)
        case EVENT_SUB_GROUP_PERFORMANCE:
          return getWind2EventNestedXML(data)
        case SUB_GROUP_PERFORMANCE:
          return getWind2SubgroupPerformanceXML(data)
        case STORAGE:
          return getWindStorageXML(data)
        case STORAGE_PERFORMANCE:
          return getWindStoragePerformanceXML(data)
      }
    },
    [data, selectedType]
  )

  const excelData = useMemo(
    _ => {
      switch (selectedType) {
        case PLANT:
          return getWind2PlantXLSX(data, excelHeaders)
        case SUB_GROUP:
          return getWind2SubgroupXLSX(data, excelHeaders)
        case EVENT:
          return getWind2EventNestedXLSX(data, excelHeaders)
        case EVENT_SUB_GROUP_PERFORMANCE:
          return getWind2EventSubgroupPerformanceXLSX(
            data,
            excelHeaders,
            data2,
            PerformanceIoHeaders
          )
        case SUB_GROUP_PERFORMANCE:
          return getWind2SubgroupPerformanceXLSX(data, excelHeaders)
        case STORAGE:
          return getWind2StorageXLSX(data, excelHeaders)
        case STORAGE_PERFORMANCE:
          return getWind2StoragePerformanceXLSX(data, excelHeaders)
      }
    },
    [selectedType, data, excelHeaders, data2]
  )

  const performanceXmlString = useMemo(
    _ => {
      if (selectedType === EVENT_SUB_GROUP_PERFORMANCE) {
        return getWind2SubgroupPerformanceXML(data2)
      }
    },
    [data2, selectedType]
  )

  const exportXMLFile = _ => {
    const fileName =
      selectedType === EVENT_SUB_GROUP_PERFORMANCE ? EVENT : selectedType
    exportData(new Blob([xmlString]), 'text/plain', 'WIND_' + fileName + '.xml')
    if (selectedType === EVENT_SUB_GROUP_PERFORMANCE) {
      exportData(
        new Blob([performanceXmlString]),
        'text/plain',
        'WIND_' + SUB_GROUP_PERFORMANCE + '.xml'
      )
    }
    // setIsRetrived(false)
    // onChange()
  }

  const exportXLSXFile = async _ => {
    const fileName = 'WIND_' + selectedType
    const userId = 'GADS'

    const fileBlob = await writeToExcel(excelData, userId)
    saveAs(fileBlob, fileName)
    // setIsRetrived(false)
    // onChange()
  }
  const handleExport = e => {
    if (e.key === XML) exportXMLFile()
    else if (e.key === EXCEL) exportXLSXFile()
  }
  const menu = (
    <Menu onClick={handleExport}>
      <Menu.Item key={XML}>XML</Menu.Item>
      <Menu.Item key={EXCEL}>EXCEL</Menu.Item>
    </Menu>
  )

  return (
    <div>
      <CriteriaRow
        css={{
          width: '100%',
          display: 'grid',
          gridTemplateColumns:
            '250px 300px 280px 150px   150px 130px 130px 130px 1fr auto',
          gap: 15,
        }}
      >
        <Title>Wind NERC File Creation</Title>
        <Select
          value={selectedType}
          style={{ width: '100%' }}
          onChange={plantId => {
            setSelectedType(plantId)
            setPlantSelected([])
            onChange()
          }}
        >
          <Select.Option
            key={EVENT_SUB_GROUP_PERFORMANCE}
            value={EVENT_SUB_GROUP_PERFORMANCE}
          >
            Event & Subgroup Performance
          </Select.Option>
          <Select.Option key={EVENT} value={EVENT}>
            Events
          </Select.Option>
          <Select.Option
            key={SUB_GROUP_PERFORMANCE}
            value={SUB_GROUP_PERFORMANCE}
          >
            Subgroup Performance
          </Select.Option>
          <Select.Option key={STORAGE_PERFORMANCE} value={STORAGE_PERFORMANCE}>
            {STORAGE_PERFORMANCE}
          </Select.Option>
          <Select.Option key={PLANT} value={PLANT}>
            Plant
          </Select.Option>
          <Select.Option key={SUB_GROUP} value={SUB_GROUP}>
            Subgroup
          </Select.Option>
          <Select.Option key={STORAGE} value={STORAGE}>
            {STORAGE}
          </Select.Option>
        </Select>

        <DatePicker.RangePicker
          allowClear={false}
          mode={['month', 'month']}
          format="MMM-YYYY"
          value={selectedDateRangePicker}
          placeholder={['Start month', 'End month']}
          onChange={value => {
            setSelectedDateRagePicker([
              value[0].startOf('month'),
              value[1].endOf('month'),
            ])
            onChange()
          }}
          onPanelChange={value => {
            setSelectedDateRagePicker([
              value[0].startOf('month'),
              value[1].endOf('month'),
            ])
            onChange()
          }}
        />

        {/* <SolarPlantSelection
          plantList={effectivePlant}
          onOk={setPlantSelected}
          defaultTargetKeys={plantSelected}
          onCancel={_ => {}}
        /> */}

        <Button
          type="primary"
          onClick={retrieveData}
          icon="file-add"
          style={{ width: '100%' }}
          disabled={isRetrieved}
          className="createFile"
        >
          Create File
        </Button>

        {/* <Select
          value={importType}
          style={{ width: '100%' }}
          disabled={!isRetrieved}
          onChange={type => {
            setImportType(type)
          }}
        >
          <Select.Option key={EXCEL} value={EXCEL}>
            Excel
          </Select.Option>
          <Select.Option key={XML} value={XML}>
            Xml
          </Select.Option>
        </Select> */}

        <Dropdown overlay={menu} disabled={!isRetrieved}>
          <Button
            type="primary"
            //   onClick={importType === XML ? exportXMLFile : exportXLSXFile}
            icon="caret-right"
            style={{ width: '100%' }}
            // disabled={data.length <= 0}
            //  disabled={!isRetrieved}
            className="continue"
          >
            Continue
          </Button>
        </Dropdown>

        <Button
          type="danger"
          onClick={onChange}
          icon="stop"
          style={{ width: '100%' }}
          // disabled={data.length <= 0}
          disabled={!isRetrieved}
          className="abort"
        >
          Abort
        </Button>
        <Filler />
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr',
            gap: '10px',
          }}
        >
          <Button
            style={{ width: '150px' }}
            type="primary"
            onClick={_ => {
              const plAll = effectivePlant.map(({ plantId }) => plantId)
              setPlantSelected(plAll)
              onChange()
            }}
          >
            Select All Plant
          </Button>
          <Button
            style={{ width: '150px' }}
            type="primary"
            onClick={_ => {
              setPlantSelected([])
              onChange()
            }}
          >
            Clear All Plant
          </Button>
        </div>
      </CriteriaRow>
      <CriteriaRow css={{ paddingTop: '0px' }}>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
            alignContent: 'flex-start',
            height: effectivePlant.length < 10 ? '10vh' : '20vh',
            maxHeight: '20vh',
            overflow: 'auto',
            border: '1px solid #eee',
            borderRadius: '5px',
            padding: '10px',
            // paddingBottom: '10px',
          }}
        >
          {effectivePlant.map(({ plantName, plantId }) => (
            <div
              key={plantId}
              style={{
                flex1: `0 0 100px`,
                width: '250px',
                overflow: 'hidden',
              }}
            >
              <Checkbox
                key={plantId}
                style={{ display: 'block' }}
                checked={plantSelected.includes(plantId)}
                // eslint-disable-next-line no-unused-vars
                onChange={checked => {
                  if (plantSelected.includes(plantId)) {
                    setPlantSelected(plantSelected.filter(p => p !== plantId))
                  } else setPlantSelected([...plantSelected, plantId])
                }}
              >
                {plantId}-{plantName}
              </Checkbox>
            </div>
          ))}
        </div>
      </CriteriaRow>
      {/* <CriteriaRow>
        <div style={{ width: '100%', height: '100px', overflow: 'auto' }}>
          <Select
            showSearch
            placeholder="Select Plant"
            value={plantSelected}
            style={{ width: '100%' }}
            onChange={plantId => {
              if (plantId.includes('ALL')) {
                setPlantSelected(effectivePlant.map(({ plantId }) => plantId))
              } else setPlantSelected(plantId)
              onChange()
            }}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            mode="multiple"
            allowClear
          >
            <Select.Option key="ALL" value="ALL">
              ALL
            </Select.Option>
            {effectivePlant.map(({ plantName, plantId }) => (
              <Select.Option key={plantId} value={plantId}>
                {plantName}
              </Select.Option>
            ))}
          </Select>
        </div>
      </CriteriaRow> */}
      <FullHeightSizer heightOffset={320} widthOffset={20}>
        {({ height, width }) => (
          <Content style={{ padding: '10px', height, width }}>
            <Tabs activeKey={activeKey} onChange={setActiveKey} type="card">
              {selectedType === EVENT_SUB_GROUP_PERFORMANCE && (
                <Tabs.TabPane key="eventData" tab="Event Data">
                  <div style={{ height, width }}>
                    <Grid
                      sortEnabled
                      data={data}
                      headers={windHeaders}
                      altBgColor="#ebebeb"
                      render={virtualizedGridRenderer({
                        autoFixColByKey: false,
                        rowHeaderRender,
                        height: height - 80,
                        width: width - 30,

                        // cellRender: performanceDoubleClick,
                      })}
                      //   fuzzyFilter={fuzzyFilter}
                      isEditable={false}
                      selectionMode="single"
                      selectionType="row"
                      // initialSortOptions={headers}
                    />
                  </div>
                </Tabs.TabPane>
              )}
              {selectedType === EVENT_SUB_GROUP_PERFORMANCE && (
                <Tabs.TabPane key="data" tab="Performance Data">
                  <div style={{ height, width }}>
                    <Grid
                      sortEnabled
                      data={data2}
                      headers={Wind2PerformanceIoHeaders}
                      altBgColor="#ebebeb"
                      render={virtualizedGridRenderer({
                        autoFixColByKey: false,
                        rowHeaderRender,
                        height: height - 80,
                        width: width - 30,

                        // cellRender: performanceDoubleClick,
                      })}
                      //   fuzzyFilter={fuzzyFilter}
                      isEditable={false}
                      selectionMode="single"
                      selectionType="row"
                      // initialSortOptions={headers}
                    />
                  </div>
                </Tabs.TabPane>
              )}
              {selectedType !== EVENT_SUB_GROUP_PERFORMANCE && (
                <Tabs.TabPane key="data" tab="Data">
                  <div style={{ height, width }}>
                    <Grid
                      sortEnabled
                      data={data}
                      headers={windHeaders}
                      altBgColor="#ebebeb"
                      render={virtualizedGridRenderer({
                        autoFixColByKey: false,
                        rowHeaderRender,
                        height: height - 80,
                        width: width - 30,

                        // cellRender: performanceDoubleClick,
                      })}
                      //   fuzzyFilter={fuzzyFilter}
                      isEditable={false}
                      selectionMode="single"
                      selectionType="row"
                      // initialSortOptions={headers}
                    />
                  </div>
                </Tabs.TabPane>
              )}

              <Tabs.TabPane
                key="xml1"
                tab={
                  selectedType === EVENT_SUB_GROUP_PERFORMANCE
                    ? 'Event XML'
                    : 'XML'
                }
              >
                <TextArea
                  value={xmlString}
                  style={{ height: height - 80, width }}
                />
              </Tabs.TabPane>
              {selectedType === EVENT_SUB_GROUP_PERFORMANCE && (
                <Tabs.TabPane
                  key="xml2"
                  tab={
                    selectedType === EVENT_SUB_GROUP_PERFORMANCE
                      ? 'Performance XML'
                      : 'XML'
                  }
                >
                  <TextArea
                    value={performanceXmlString}
                    style={{ height: height - 80, width }}
                  />
                </Tabs.TabPane>
              )}
              <Tabs.TabPane key="errors" tab="Warnings/Errors" forceRender>
                <div>
                  <JcTmpErrorTable
                    errors={jcTmpErrors}
                    scroll={{ y: height - 120 }}
                  />
                </div>
              </Tabs.TabPane>
            </Tabs>
          </Content>
        )}
      </FullHeightSizer>
    </div>
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
})
export default connect(mapStateToProps)(Wind2FileCreation)
